export const obtenerHoraLarga = (fecha) => {
    return (
        ((fecha.getHours() < 10) ? "0" : "") + fecha.getHours() + ":" +
        ((fecha.getMinutes() < 10) ? "0" : "") + fecha.getMinutes() + ":" +
        ((fecha.getSeconds() < 10) ? "0" : "") + fecha.getSeconds());
}